import PropTypes from 'prop-types'
import { rgba } from 'polished'
import { Link } from 'react-router-dom'

import theme from 'theme'
import Text from 'components/common/Text'
import Button from 'components/common/Button'

export function Header(props) {
  return (
    <Text
      as="h1"
      color="white"
      css={{
        fontSize: theme.fontSizes[7],
        textShadow: `0 0 10px ${rgba(theme.colors.black[0], theme.opacity[0])}`
      }}
      {...props}
    />
  )
}

export function Subheader(props) {
  return (
    <Text
      as="h3"
      color="white"
      css={{
        textShadow: `0 0 5px ${rgba(theme.colors.black[0], theme.opacity[0])}`
      }}
      {...props}
    />
  )
}

export function OnboardingButton(props) {
  return (
    <Button
      css={{ minWidth: theme.space[8], justifyContent: 'center' }}
      {...props}
    />
  )
}

export function OnboardingLink({
  as: Component = Link,
  type = 'default',
  ...rest
}) {
  return (
    <Component
      css={[
        type === 'contrast' && {
          color: theme.colors.white[0],

          '&:hover, &:focus': {
            color: theme.colors.white[0]
          }
        },

        type === 'muted' && {
          color: theme.colors.steel[1],
          '&:hover, &:focus': {
            color: theme.colors.steel[0]
          }
        }
      ]}
      {...rest}
    />
  )
}

OnboardingLink.propTypes = {
  as: PropTypes.any,
  type: PropTypes.oneOf(['contrast', 'muted', 'default']),
  muted: PropTypes.bool
}
